module.exports = __webpack_public_path__ + "img/logo_2.ced4c4df.png";